// Fixed per-field convention, not user-configurable: Cost and Base/UoM Price
// are trade/wholesale figures, recorded ex-GST to match standard AU B2B
// invoicing. RRP/Reference Price isn't listed here — its GST label switches
// with the tenant's Track RRP setting (see getDerivedRrp in
// productReportShared.js) rather than being fixed.
export const GST_LABEL = {
  cost: 'Ex GST',
  basePrice: 'Ex GST',
  uomPrice: 'Ex GST',
};
